import React, {useState} from 'react';
import {Col, Row, Button, Collapse} from 'reactstrap';
import WarningMessageComponent from '../Shared/Components/Warning/WarningMessageComponent';
import AbroadPackageTab from '../Shared/Components/AbroadPackageTab';

const PopupDefaultPackageDataComponent = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    if (!isOpen) {
      props.gaOnOpenDefaultPackage && props.gaOnOpenDefaultPackage();
    }

    setIsOpen(!isOpen);
  };

  return (
    <div className='popup-default-package-data'>
      <Row>
        <Col>
          <Button color='link' className={`popup-default-package-collapse-btn`} type='button' onClick={toggle}>
            לפרטי החבילה הקיימת
            {isOpen ? <span className='newPurple mr-1 bold font-12'>&#x2715;</span> : <span className='newPurple mr-1 bold'>&#43;</span>}
          </Button>
        </Col>
      </Row>

      <Collapse isOpen={isOpen}>
        <AbroadPackageTab packageData={props.defaultSOC} supportedApps={props.supportedApps} context={props.context} />
        <Row>
          {(props.unsupportedCountries || !props.isSuitableDates) && (
            <WarningMessageComponent
              unsupportedCountries={props.unsupportedCountries}
              isSuitableDates={props.isSuitableDates}
              isBusiness={props.isBusiness}
            />
          )}
        </Row>
      </Collapse>
    </div>
  );
};

export default PopupDefaultPackageDataComponent;
